import { render, staticRenderFns } from "./DividedPayForm.vue?vue&type=template&id=06bc05b3&"
import script from "./DividedPayForm.vue?vue&type=script&lang=ts&"
export * from "./DividedPayForm.vue?vue&type=script&lang=ts&"
import style0 from "./DividedPayForm.vue?vue&type=style&index=0&id=06bc05b3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports